import React, { useState, useContext, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppContext, useAppContext } from "../Contexts/AppContext";
import Constants from "../Utilities/Constants";
import { isValidPhone, isValidEmail, formatPhone } from "../Utilities/ValidationUtils";
import axios from "axios";
import ChangePassword from "../Components/ChangePassword";
import Orders from "../Components/Orders";
import { usePageTitle } from "../Utilities/usePageTitle";


const Profile = () => {
    usePageTitle('הפרופיל שלי');

    const { customer, setCustomer } = useContext(AppContext);
    const { setShowLoginModal } = useAppContext();
    const navigate = useNavigate();
    const phoneRef = useRef(null);
    const emailRef = useRef(null);
    const [yishuvim, setYishuvim] = useState([]);
    const [ component, setComponent ] = useState('VerifyStock');
    const [loading, setLoading] = useState(true);
    const [showPhoneError, setShowPhoneError] = useState(false);
    const [showEmailError, setShowEmailError] = useState(false);
    const [showSubmitError, setShowSubmitError] = useState(false);
    const isCustomerLoading = customer === undefined;

    useEffect(() => {
        if (customer === null) {
            setShowLoginModal(true);
        }
    }, [customer, setShowLoginModal]);

    useEffect(() => {
        async function fetchYishuvim() {
            try {
                const url = Constants.API_URL_YISHUVIM;
                const response = await axios.get(url);
                setYishuvim(response.data);
            } catch (error) {
                console.error("Error fetching yishuvim:", error);
            } finally {
                setLoading(false); // Set loading to false after fetching
            }
        }
    
        fetchYishuvim();
    }, []);
    

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setCustomer(values => ({...values, [name]: value}));

        if (name === 'phoneNo') {
            setShowPhoneError(false);
        }

        if (name === 'email') {
            setShowEmailError(false);
        }

        if (showSubmitError) {
            setShowSubmitError(false);
        }
    }

    const handleSubmit = async (event) => {        
        event.preventDefault();
        setShowSubmitError(false);

        if (!validateCellular(customer?.phoneNo ?? customer?.customerPhone ?? '')) {
            return;
        }

        if (!validateEmail(customer?.email ?? '')) {
            return;
        }

        try {
            const url = Constants.API_URL_UPDATE_PROFILE;
            const json = await axios.post(url, customer);
            setCustomer(json.data);
            navigate("/");
        }
        catch (error) {
            if (error.response) {
                setShowSubmitError(true);
            }
            else {
                console.error(error);
            }
        }
    };

    function validateCellular(cellPhone) {
        if (isValidPhone(cellPhone))
        {
            setShowPhoneError(false);
            return true;
        } 
        else {
            setShowPhoneError(true);
            phoneRef.current.focus();
            return false;
        }
    }

    function validateEmail(email) {
        if (isValidEmail(email))
        {
            setShowEmailError(false);
            return true;
        } 
        else {
            setShowEmailError(true);
            emailRef.current.focus();
            return false;
        }
    }

    const PersonalMenu  = () => {

        return (
            <>
            <h3 className="my-5 text-center">האזור האישי שלי</h3>
            <ul className="p-0">
                <li><button className="btn p-3" onClick={() => setComponent('VerifyStock')} >ההזמנות שלי</button></li>
                <li><button className="btn p-3" onClick={() => setComponent('DeliveryAddress')} >פרטים כלליים</button></li>
                <li><button className="btn p-3" onClick={() => setComponent('DeliverySelect')} >החלפת סיסמה</button></li>
            </ul>
            </>
        )
    }

    const ProfileForm = (() => {
        if (!customer || isCustomerLoading) {
            return null;
        }

        if (loading) {
            return <p>Loading...</p>; // Show a loading message while fetching data
        }
        
        return (
            <div className="container">
                <div className="wrapper">
                    <form method="post">
                        <div className="text-danger"></div>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="firstName" className="form-label">שם פרטי</label>
                                <input name="firstName" id="firstName" className="form-control" value={customer.firstName ?? ''}
                                    onChange={handleChange} />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="lastName" className="form-label">שם משפחה</label>
                                <input name="lastName" id="lastName" className="form-control" value={customer.lastName ?? ''}
                                    onChange={handleChange} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="phoneNo" className="form-label">טלפון</label>
                                <input name="phoneNo" id="phoneNo" className="form-control" ref={phoneRef} value={formatPhone(customer.phoneNo ?? customer.customerPhone)}
                                    onChange={handleChange} onBlur={(e)=>validateCellular(e.target.value)} />
                                <span className={`text-danger ${showPhoneError ? '' : 'd-none'}`} >נא הקש מספר טלפון תקין</span>
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="email" className="form-label">דואר אלקטרוני</label>
                                <input name="email" id="email" className="form-control"  ref={emailRef} value={customer.email ?? ''}
                                    onChange={handleChange} onBlur={(e)=>validateEmail(e.target.value)} />
                                <span className={`text-danger ${showEmailError ? '' : 'd-none'}`}>נא הקש כתובת דואר אלקטרוני תקין</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="address" className="form-label">כתובת</label>
                                <input name="address" id="address" className="form-control" onChange={handleChange} value={customer.address ?? ''}/>
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="yishuvId" className="form-label">ישוב</label>
                                <select name="yishuvId" id="yishuvId" className="form-select" value={customer.yishuvId ?? ''} onChange={handleChange} >
                                    <option value="">בחר ישוב...</option>
                                    {
                                        yishuvim.map((yishuv) => {
                                        return (<option key={yishuv.yishuvId} value={yishuv.yishuvId}>
                                            {yishuv.yishuvName}</option>)
                                        })
                                    }
                                    </select>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="entrance" className="form-label">כניסה/קומה/דירה</label>
                                <input name="entrance" id="entrance" className="form-control" onChange={handleChange} value={customer.entrance ?? ''}/>
                            </div>
                            <div className="col-md-3 mb-3">
                                <label htmlFor="intercom" className="form-label">אינטרקום</label>
                                <input name="intercom" id="intercom" className="form-control" onChange={handleChange} value={customer.intercom ?? ''}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <label htmlFor="notes" className="form-label">הערות לכתובת</label>
                                <input name="notes" id="notes" className="form-control" onChange={handleChange} value={customer.notes ?? ''}/>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-md-12">
                                <span className={`invalid-feedback ${showSubmitError ? 'd-block' : 'd-none'}`}>משתמש קיים במערכת</span>
                            </div>
                        </div>

                        <div className="buttons mt-4">
                            <input type="submit" value="שמור" className="btn btn-primary" onClick={handleSubmit} />
                            <Link to='/' className="btn btn-secondary">בטל</Link>
                        </div>
                    </form>
                </div>
            </div>
        );
    })();

    if (isCustomerLoading) {
        return <p className="text-center m-5">טוען פרטי משתמש...</p>;
    }

    if (customer === null) {
        return null;
    }

    return (
        <>
        <div className="container" style={{maxWidth: '1200px'}}>
            <div className="row">
                <div className="col-md-3 vertical-nav">
                    <PersonalMenu />
                </div>
                    <div className="col-md-9 mt-5">
                        {component === 'DeliveryAddress' && ProfileForm}
                        {component === 'DeliverySelect' && <ChangePassword />}
                        {component === 'VerifyStock' && <Orders />}
                    </div>
            </div>
        </div>
        </>
    )  
}



export default Profile;
